"use client";

import { CLink } from "@/components/common/customLink/CustomLink";
import LazyLoadedVideo from "@/components/common/LazyLoadedVideo";

interface IProps {
  desktopUrl: string;
  mobileUrl: string;
  link: string;
  thumbnail?: {
    desktop?: string;
    mobile?: string;
  };
}

export const VideoBanner = ({ desktopUrl, link, mobileUrl, thumbnail }: IProps) => {
  return (
    <div className="h-full w-full">
      <CLink href={link} className="hidden md:block">
        <LazyLoadedVideo
          className="aspect-[1.95/1] w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          src={desktopUrl}
          poster={thumbnail?.desktop}
        />
      </CLink>

      <CLink href={link} className="md:hidden">
        <LazyLoadedVideo
          className="aspect-[375/482] w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          src={mobileUrl}
          poster={thumbnail?.mobile}
        />
        {/* <video
          className="aspect-[375/482] h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={mobileUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
      </CLink>
    </div>
  );
};
